const allinvoicedata = { data: [], loading: true };
const allvoidinvoicedata = { data: [], loading: true };
const alladdinvoicepopulate = { data: [], loading: true };
const alladdunitinvoicepopulate = { data: [], loading: true };

export const GetAllInvoiceRed = (state = allinvoicedata, action) => {
  switch (action.type) {
    case "get_invoicedata":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAllVoidInvoiceRed = (state = allvoidinvoicedata, action) => {
  switch (action.type) {
    case "get_voidinvoicedata":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAddInvoicePopulateRed = (state = alladdinvoicepopulate, action) => {
  switch (action.type) {
    case "get_addinvoicepopulate":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};

export const GetAddUnitInvoicePopulateRed = (state = alladdunitinvoicepopulate, action) => {
  switch (action.type) {
    case "get_addunitinvoicepopulate":
      return {
        data: action.payload,
        loading: action.loading,
      };
    default:
      return state;
  }
};
